import styled from "styled-components";
import logo from "../assets/img/footer/white-logo.svg";
import stripes from "../assets/img/footer/footer-stripes.png";
import slash from "../assets/img/slash.svg";
import address from "../assets/img/footer/address.svg";
import instagram from "../assets/img/footer/instagram.svg";
import google from "../assets/img/footer/google.svg";
import twitter from "../assets/img/footer/twitter.svg";
import facebook from "../assets/img/footer/facebook.svg";
import linkedin from "../assets/img/footer/linkedin.svg";
import email from "../assets/img/footer/mail.svg";
import phone from "../assets/img/footer/phone.svg";
import { useTranslation } from "react-i18next";

const Box = styled.div`
  padding: 15px 0;
  position: relative;
  width: 100%;
  background-image: url(${stripes});
  background-color: #2d2d2d;
  background-position: 65px;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #272727;
    z-index: -1;
  }

  @media (max-width: 1000px) {
    padding: 40px 20px;
    background-position: -761px 229px;
    background-repeat: no-repeat;

    &:after {
      background-color: #2d2d2d;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  max-width: 1374px;
  margin: 0px auto;

  @media (max-width: 1000px) {
    gap: 30px;
    flex-direction: column;
  }
`;

const Column = styled.div`
  text-align: start;

  &:first-of-type {
    order: ${(p) => (p.isRtl ? "unset" : "0")};
  }
  &:last-of-type {
    @media (max-width: 1000px) {
      margin-bottom: 48px;
    }
  }
`;

const BulletText = styled.p`
  color: #fff;
  margin-bottom: 20px;
  margin-top: 0;
  font-size: 14px;
  white-space: pre-wrap;
  margin-inline-start: "18px";

  img {
    margin-inline-end: 12px;
    /* margin-right: ${(p) => (p.isRtl ? "12px" : "0")};
  margin-left: ${(p) => (p.isRtl ? "0" : "12px")};
  vertical-align: middle; */
  }
`;

const Slash = styled.img`
  margin-inline-end: 12px;
`;

const FooterLink = styled.a`
  color: #fff;
  margin-bottom: 10px;
  font-size: 14px;
  text-decoration: none;
  text-transform: capitalize;

  &:hover {
    border-bottom: none;
  }
`;

const Heading = styled.p`
  font-size: 20px;
  margin-top: 0;
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 48px;

  img {
    margin-right: 6px;
    transform: ${(p) => (p.isRtl ? "scaleX(-1)" : "unset")};
  }

  @media (max-width: 1000px) {
    margin-bottom: 12px;
  }
`;

const FooterMenu = ({ isRtl }) => {
  const { t, i18n } = useTranslation("footer");

  return (
    <Box isRtl={isRtl}>
      <Container>
        <Column isRtl={isRtl}>
          <img
            src={logo}
            alt="logo"
            style={{
              maxWidth: "250px",
            }}
          />
          <div
            style={{
              display: "flex",
              flexWrap: "nowrap",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-end",
              maxWidth: "250px",
              marginTop: "25px",
            }}
          >
            {/* <FooterLink href="#">
              <img src={whatsapp} alt="whatsapp" />
            </FooterLink> */}
            <FooterLink href="#">
              <img src={google} alt="google" />
            </FooterLink>
            <FooterLink href="https://www.instagram.com/acp_1965/">
              <img src={instagram} alt="instagram" />
            </FooterLink>
            <FooterLink href="#">
              <img src={linkedin} alt="linkedin" />
            </FooterLink>
            {/* <FooterLink href="https://www.pinterest.com/acpdigi/">
              <img src={pinterest} alt="pinterest" />
            </FooterLink> */}
            <FooterLink href="https://www.facebook.com/ACPopenair">
              <img src={facebook} alt="facebook" />
            </FooterLink>
            <FooterLink href="#">
              <img src={twitter} alt="twitter" />
            </FooterLink>
          </div>
        </Column>
        <Column isRtl={isRtl}>
          <Heading isRtl={isRtl}>
            <Slash src={slash} alt="slash" />
            {t("menu_title")}
          </Heading>
          <div
            style={{
              maxHeight: "138px",
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              columnGap: "50px",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              marginInlineStart: "30px",
            }}
          >
            <FooterLink
              title="Home"
              target="_blank"
              href={
                i18n.language === "en" ? "https://acp-ltd.co.il/?lang=en" : "https://acp-ltd.co.il/"
              }
            >
              {t("home_link")}
            </FooterLink>
            <FooterLink target="_blank" title="catalog" href="/catalog">
              {t("products_link")}
            </FooterLink>
            <FooterLink
              title="about us"
              target="_blank"
              href={
                i18n.language === "en"
                  ? "https://acp-ltd.co.il/about/?lang=en"
                  : "https://acp-ltd.co.il/%d7%90%d7%95%d7%93%d7%95%d7%aa/"
              }
            >
              {t("about_link")}
            </FooterLink>
            <FooterLink
              title="colors catalog"
              target="_blank"
              href={
                i18n.language === "en"
                  ? "https://acp-ltd.co.il/color-catalog/?lang=en"
                  : "https://acp-ltd.co.il/%d7%a7%d7%98%d7%9c%d7%95%d7%92-%d7%a6%d7%91%d7%a2%d7%99%d7%9d/"
              }
            >
              {t("color_catalog_link")}
            </FooterLink>
            <FooterLink
              title="blog"
              target="_blank"
              href={
                i18n.language === "en"
                  ? "https://acp-ltd.co.il/articles/?lang=en"
                  : "https://acp-ltd.co.il/%d7%9e%d7%90%d7%9e%d7%a8%d7%99%d7%9d/"
              }
            >
              {t("articles_link")}
            </FooterLink>
          </div>
        </Column>
        <Column isRtl={isRtl}>
          <Heading isRtl={isRtl}>
            <Slash src={slash} alt="slash" />
            {t("contact_title")}
          </Heading>
          <div
            style={{
              marginInlineStart: "30px",
            }}
          >
            <BulletText isRtl={isRtl}>
              <img src={address} alt="address" />
              {t("address")}
            </BulletText>
            <BulletText isRtl={isRtl}>
              <img src={phone} alt="phone" />
              {t("telephone")}
            </BulletText>
            <BulletText isRtl={isRtl}>
              <img src={email} alt="email" />
              {t("email")}
            </BulletText>
          </div>
        </Column>
      </Container>
    </Box>
  );
};
export default FooterMenu;
